import React from "react";
import ExcelImportPage from "./ExcelImportPage";

function HSCodeImport() {
  return (
    <ExcelImportPage
      title="درون‌ریزی کدهای HS"
      endpoint="/customs/import-hscode/"
      fileFieldName="excel_file"
      description="فایل اصلی کدهای HS را بارگذاری کنید تا ردیف‌های تعرفه ایجاد یا به‌روزرسانی شوند. کدها از روی فایل اکسل خوانده می‌شوند و فصل و سرگروه مرتبط در زمان درون‌ریزی تعیین می‌شود."
      requiredColumns={[
        "code",
        "title",
        "titleEn",
        "tradeBenefit",
        "suq",
        "commodityPriority",
        "importDuty",
        "customsDuties",
      ]}
    />
  );
}

export default HSCodeImport;
